import { useMutation, useQuery } from '@tanstack/react-query';
import { accountQueries, accountMutations } from './accounts.queries';

export function useAccounts(options?: { suspense?: boolean }) {
  return useQuery({ ...accountQueries.list(), ...options });
}

export function useAccount(id: number, options?: { suspense?: boolean }) {
  return useQuery({ ...accountQueries.detail(id), ...options });
}

export function useUpdateAccount() {
  return useMutation(accountMutations.update());
}
